import { createSlice } from "@reduxjs/toolkit";

interface ContactUsModalState {
  footerModalOpen: boolean;
  scrollPosition: number;
}

const initialState: ContactUsModalState = {
  footerModalOpen: false,
  scrollPosition: 0
};

const contactUsModalSlice = createSlice({
  name: "contactUsModal",
  initialState,
  reducers: {
    openContactUsModal: (state) => {
      // Save current scroll position
      state.scrollPosition = window.scrollY;
      // Lock scroll
      document.body.style.position = "fixed";
      document.body.style.top = `-${state.scrollPosition}px`;
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";
      state.footerModalOpen = true;
    },
    closeContactUsModal: (state) => {
      // Restore scroll
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflow = "";
      window.scrollTo(0, state.scrollPosition);
      state.footerModalOpen = false;
    }
  }
});

export const { openContactUsModal, closeContactUsModal } = contactUsModalSlice.actions;
export default contactUsModalSlice.reducer;
